let deferredPrompt = null;

export function initPWAInstall() {
	window.addEventListener("beforeinstallprompt", (event) => {
		// Prevent Chrome from showing its automatic prompt
		event.preventDefault();

		// Save the event for later
		deferredPrompt = event;

		// Tell the application that installation is available
		window.dispatchEvent(new CustomEvent("pwa-install-available"));
	});

	window.addEventListener("appinstalled", () => {
		console.log("[PWA] Trekko installed");

		deferredPrompt = null;

		window.dispatchEvent(new CustomEvent("pwa-installed"));
	});
}

export function isPWAInstalled() {
	return (
		window.matchMedia("(display-mode: standalone)").matches ||
		window.navigator.standalone === true
	);
}

export async function installPWA() {
	if (!deferredPrompt) {
		return false;
	}

	deferredPrompt.prompt();

	const { outcome } = await deferredPrompt.userChoice;

	console.log("[PWA] Installation choice:", outcome);

	deferredPrompt = null;

	return outcome === "accepted";
}
